import React, {useState} from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap';
// import alumni from "./alumni.json";
// import seniors from "./seniors.json";
// import juniors from "./juniors.json";
// import {Link} from "react-router-dom"
import styles from "./Team.module.css";
import { faLinkedin, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Picmodal from "./PictureModal";


function TeamPage(props) {
    // console.log(props);
    const {alumni,seniors,juniors,teampic}=props
    const [modalShow, setModalShow] = useState(false);
    const [photoselect, setPhotoSelect] = useState(false);
    return (
        <div>
            <Picmodal show={modalShow} onHide={() => setModalShow(false)} image={photoselect}></Picmodal>
            <Card>
            <Card.Img style={{ width: '100%', border: '0px', height:'45vw', minHeight:"500px"}} src={teampic} alt="group"/>
            <Card.ImgOverlay className={"d-flex flex-column justify-content-start "+styles.ImageText} style={{height:'45vw', minHeight:"500px"}}>
                <div className={styles.TextBox}>
                    <br/>
                    <h1>Meet the Team</h1>
                    <br/>
                    <br/>
                    <h4>A collective of like-minded folks on a mission to build optimized solutions and seamlessly maintain them</h4>
                    <br/>
                </div>
            </Card.ImgOverlay>
            </Card>
            <Container>
            <br/>
            <div align="center">
            <h1>Seniors Members of Project Cell</h1>
            <hr style={{width:"200px",height:"2px",color:"white",backgroundColor:"black",borderRadius:"15%"}} />
            </div>
            <Container fluid>
            <Row className="justify-content-md-center">
                {seniors.map((member,index)=>{
                    return(
                    <Col xs={12} md={6} lg={4} style={{alignContent:"center"}}>
                        <a href={member.Linkedin}>
                        <Card className={styles.TeamMember}>
                        <Card.Img src={member.imageURL} alt={member.name} onDrag={() => {setPhotoSelect(member.imageURL); setModalShow(true)}} />
                        <Card.ImgOverlay className={"d-flex flex-column justify-content-start "+styles.Texter}>
                        {/* <Card.ImgOverlay classname={styles.Texter}> */}
                        <Row className={styles.Rower}>
                        <FontAwesomeIcon className={styles.Icons} icon={faLinkedinIn}/>
                        <Col xs={11}><Card.Title>{member.name}</Card.Title></Col>
                        </Row>
                            {member.position&&<Card.Text>{member.position}</Card.Text>}
                        </Card.ImgOverlay>
                        </Card>
                        </a>
                    </Col>
                )})}
            </Row>
            </Container>
            <br/>
            <div align="center">
            <h1>Juniors Members of Project Cell</h1>
            <hr style={{width:"200px",height:"2px",color:"white",backgroundColor:"black",borderRadius:"15%"}} />
            </div>
            <Container fluid>
            <Row className="justify-content-md-center">
                {juniors.map((member,index)=>{
                    return(
                    <Col xs={12} md={6} lg={4} style={{alignContent:"center"}}>
                        <a href={member.Linkedin}>
                        <Card className={styles.TeamMember}>
                        <Card.Img src={member.imageURL} alt={member.name} onDrag={() => {setPhotoSelect(member.imageURL); setModalShow(true)}}/>
                        <Card.ImgOverlay className={"d-flex flex-column justify-content-start "+styles.Texter}>
                        {/* <Card.ImgOverlay classname={styles.Texter}> */}
                        <Row className={styles.Rower}>
                        <FontAwesomeIcon className={styles.Icons} icon={faLinkedinIn}/>
                        <Col xs={11}><Card.Title>{member.name}</Card.Title></Col>
                        </Row>
                            {member.position&&<Card.Text>{member.position}</Card.Text>}
                        </Card.ImgOverlay>
                        </Card>
                        </a>
                    </Col>
                )})}
            </Row>
            </Container>
            <br/>
            <div align="center">
            <h1>Alumni of Project Cell</h1>
            <hr style={{width:"200px",height:"2px",color:"white",backgroundColor:"black",borderRadius:"15%"}} />
            </div>
            <Container fluid>
            <Row className="justify-content-md-center">
                {alumni.map((member,index)=>{
                    return(
                    <Col xs={12} md={6} lg={4} style={{alignContent:"center"}}>
                        <a href={member.Linkedin}>
                        <Card className={styles.TeamMember}>
                        <Card.Img src={member.imageURL} alt={member.name} onDrag={() => {setPhotoSelect(member.imageURL); setModalShow(true)}} />
                        <Card.ImgOverlay className={"d-flex flex-column justify-content-start "+styles.Texter}>
                        {/* <Card.ImgOverlay classname={styles.Texter}> */}
                        <Row className={styles.Rower}>
                        <FontAwesomeIcon className={styles.Icons} icon={faLinkedinIn}/>
                        <Col xs={11}><Card.Title>{member.name}</Card.Title></Col>
                        </Row>
                            {member.position&&<Card.Text>{member.position}</Card.Text>}
                            {member.year&&<Card.Text>{member.year}</Card.Text>}
                        </Card.ImgOverlay>
                        </Card>
                        </a>
                    </Col>
                )})}
            </Row>
            </Container>
            </Container>
        </div>
    )
}

export default TeamPage
